import ApiService, { ApiArguments } from '@/api/api_service';
import {
  PromptTemplatePlaceholderApi,
} from '@/api/openapi';

export class PromptTemplatePlaceholderService extends ApiService {
  api = new PromptTemplatePlaceholderApi(undefined, this.baseUrl, this.httpInstance);

  constructor() {
    super(true);
  }

  async getTranscriptionSummaryPromptTemplatePlaceholders({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getTranscriptionSummaryPromptTemplatePlaceholders(options),
      errorHandlers,
    );
  }

  async getHearingItemExtractionPromptTemplatePlaceholders({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getHearingItemExtractionPromptTemplatePlaceholders(options),
      errorHandlers,
    );
  }

  async getFollowUpNecessityJudgmentPromptTemplatePlaceholders({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options),
      errorHandlers,
    );
  }

  async getNextActionSuggestionExtractionPromptTemplatePlaceholders({
    options,
    errorHandlers,
  }: ApiArguments<never> | undefined = {}) {
    return this.checkResponse<string[]>(
      this.api.getNextActionSuggestionExtractionPromptTemplatePlaceholders(options),
      errorHandlers,
    );
  }
}
